// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"4028": "2e4c8003","494": "40775784","5545": "20927b2f","8561": "f9cad78a",}[chunkId] + ".css"
}